<template>
  <div class="ts-p-3">
    <h6
      class="ts-shadow-rounded ts-uppercase ts-p-2 ts-rounded-md"
      style="width:fit-content"
    >{{ $t('purchaseOrder.ItemOrdered') }}</h6>
    <div class="ts-overflow-y-scroll max-h ts-mt-3">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2"
            >{{ $t('purchaseOrder.barcode') }}</th>
            <th class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2">{{ $t('purchaseOrder.name') }}</th>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2"
            >{{ $t('purchaseOrder.uom') }}</th>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
            >{{ $t('purchaseOrder.quantity') }}</th>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
            >{{ $t('purchaseOrder.costThb') }}</th>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
            >{{ $t('purchaseOrder.costUsd') }}</th>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-w-24"
            >{{ $t('purchaseOrder.discount') }}</th>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2"
            >{{ $t('purchaseOrder.disType') }}</th>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
            >{{ $t('purchaseOrder.amount') }}</th>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
            >{{ $t('purchaseOrder.amountInBath') }}</th>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
            >{{ $t('purchaseOrder.maxReorder') }}</th>
            <th
              class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2 ts-text-center"
            >{{ $t('purchaseOrder.alloworder') }}</th>
            <th class="ts-uppercase ts-border-b ts-whitespace-no-wrap ts-py-2 ts-px-2"
              style="width:90px"
            >
              {{ $t('actions')}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, index) in model.po_detail" :key="index">
            <td class="ts-w-32">
              <input type="text"
                :value="findProduct(d.product_id) ? findProduct(d.product_id).barcode : ''"
                class="ts-border-b ts-py-1 ts-px-2 ts-w-full ts-outline-none"
                readonly
              >
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.product_id')"
              >{{ errors.first('po_detail.' + index + '.product_id') }}</div>
            </td>
            <td
              class="ts-p-2"
              style="width: 20%"
            >
              <input type="text"
               :value="findProduct(d.product_id) ? findProduct(d.product_id).product_name_en : ''"
                class="ts-border-b ts-py-1 ts-px-2 ts-w-full ts-outline-none"
                readonly
              >
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.product_id')"
              >{{ errors.first('po_detail.' + index + '.product_id') }}</div>
            </td>
            <td
              style="width:10%"
            >
              <select
                v-model.number="d.uom_id"
                class="ts-w-full ts-border-b ts-outline-none ts-py-1 ts-px-2"
                @change="onUomChange(d)"
              >
                <option 
                  v-for="(u, uIndex) in getUom(d.uom_cat_id)"
                  :key="uIndex"
                  :value="u.value">{{ u.label }}</option>
              </select>
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.uom_id')"
              >{{ errors.first('po_detail.' + index + '.uom_id') }}</div>						
            </td>
            <td class="ts-w-16">
              <input 
                v-model.number="d.qty"
                @input="calculate(d)" 
                type="number" 
                class="ts-border-b ts-outline-none ts-px-2 py ts-text-center ts-w-full"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.qty')"
              >{{ errors.first('po_detail.' + index + '.qty') }}</div>
            </td>
            <td class="ts-w-40">
              <ts-currency-input
                v-model.number="d.cost_in_bath"
                currency="฿"
                @input="onCostThb(d)"
                class="ts-border-b ts-outline-none py ts-text-right ts-w-full"
              />
              <!-- <input 
                v-model.number="d.cost_in_bath" 
                type="number"
                @input="onCostThb(d)" 
                class="ts-border-b ts-outline-none ts-px-2 py ts-text-center ts-w-full"
                :placeholder="errors.first('po_detail.' + index + '.cost_in_bath')"
                :class="errors.has('po_detail.' + index + '.cost_in_bath') ? 'ts-text-red-700' : ''"
              /> -->
            </td>
            <td class="ts-w-40">
              <ts-currency-input
                v-model.number="d.cost"
                @input="onCostUsd(d)"
                class="ts-border-b ts-outline-none py ts-text-right ts-w-full" 
              />
              <!-- <input 
                v-model.number="d.cost" 
                type="number"
                
                class="ts-border-b ts-outline-none ts-px-2 py ts-text-center ts-w-full"
                :placeholder="errors.first('po_detail.' + index + '.cost')"
                :class="errors.has('po_detail.' + index + '.cost') ? 'ts-text-red-700' : ''"
              /> -->
            </td>
            <td>
              <input 
                v-model.number="d.discount_rate"
                @input="calculate(d)"  
                type="number" 
                class="ts-border-b ts-outline-none py ts-px-2 ts-text-center ts-w-full"
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.discount_rate')"
              >{{ errors.first('po_detail.' + index + '.discount_rate') }}</div>
            </td>
            <td class="ts-w-32">
              <select
                v-model.number="d.discount_type"
                @change="calculate(d)" 
                class="ts-w-full ts-border-b ts-outline-none ts-py-1 ts-px-2"
              >
                <option value="%">%</option>
                <option value="$">$</option>
              </select>
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.discount_type')"
              >{{ errors.first('po_detail.' + index + '.discount_type') }}</div>						
            </td>
            <td class="ts-w-56">
              <ts-currency-input
                v-model.number="d.total_after_discount"
                readonly
                class="ts-border-b ts-outline-none py ts-w-full ts-text-right"  
              />
              <div
                class="validate"
                v-if="errors.has('po_detail.' + index + '.total_after_discount')"
              >{{ errors.first('po_detail.' + index + '.total_after_discount') }}</div>
            </td>
            <td>
              <ts-currency-input 
                v-model.number="d.total_after_discount_in_bath"
                currency="฿"  
                readonly
                class="ts-border-b ts-outline-none py ts-w-full ts-text-right"
              />
              <!-- <input 
                v-model.number="d.total_after_discount_in_bath" 
                type="number"
                readonly 
                class="ts-border-b ts-outline-none ts-px-2 py ts-text-center ts-w-full"
              /> -->
            </td>
            <td class="ts-w-40">
              <input 
                v-model="d.maximum_reorder_allow" 
                type="number"
                readonly
                disabled 
                class="ts-border-b ts-outline-none py ts-px-2 ts-text-center ts-bg-gray-300 ts-w-full"
              />
            </td>
            <td style="width:1%" class="ts-text-center">
              <input type="checkbox" v-model="d.alloworder">
            </td>
            <td
              style="width:1%"
              class="ts-text-center"
            >
              <a
                href="#"
                class="ts-text-red-700 hover:ts-text-red-700"
                @click.prevent="removeItem(index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
          <tr>
            <td class="ts-text-left ts-text-red-700">
              <p class="ts-font-extrabold">{{ $t('purchaseOrder.numberRow') + ': ' }} <span class="ts-font-extrabold">{{ model.po_detail.length }}</span></p>
            </td>
            <td colspan="2" class="ts-text-right ts-text-red-700">
              <span class="ts-uppercase ts-font-extrabold">{{ $t('purchaseOrder.total') }} : </span>
            </td>
            <td class="ts-text-center ts-text-red-700" valign="middle">
              <p class="ts-font-extrabold ts-mb-0">{{ $formatNumber(sumTotalQty) }}</p>
            </td>
            <td class="ts-text-center ts-text-red-700" valign="middle">
              <!-- <p class="ts-font-extrabold ts-mb-0">{{ $currencyFormat(sumTHBPrice, 'THB', 'th-TH') }}</p> -->
            </td>
            <td class="ts-text-center ts-text-red-700" valign="middle">
              <!-- <p class="ts-font-extrabold ts-mb-0">{{ $currencyFormat(sumCost) }}</p> -->
            </td>
            <td colspan="2"></td>
            <td class="ts-text-center ts-text-red-700" valign="middle">
              <p class="ts-font-extrabold ts-mb-0 ts-whitespace-no-wrap">{{ $currencyFormat(sumTotalAfterDiscount) }}</p>
            </td>
            <td class="ts-text-center ts-text-red-700" valign="middle">
              <p class="ts-font-extrabold ts-mb-0 ts-whitespace-no-wrap">{{ $currencyFormat(sumTotalAfterDiscount * model.fx_rate_thb, 'THB', '', 2) }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapGetters } from 'vuex'

export default {
  name: 'purchaseOrderItem',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      newRow: {
        product_id: null,
				uom_id: null,
				uom_cat_id: null,
        qty: 1,
        maximum_reorder_allow: 0,
        alloworder: false,
        cost: 0,
        cost_in_bath: 0,
        discount_rate: 0,
        discount_type: '%',
        total_after_discount: 0,
      }
    }
	},
	computed: {
		...mapGetters('purchaseOrder/order', ['getProduct', 'getUom', 'findProduct', 'getCostPrice']),
    sumTotalAfterDiscount(){
      return _.round(_.sumBy(this.model.po_detail, 'total_after_discount'), 4);
    },
    sumTotalQty(){
      return _.sumBy(this.model.po_detail, 'qty');
    },
    sumTHBPrice() {
      return _.sumBy(this.model.po_detail, 'cost_in_bath')
    },
    sumCost(){
      return _.round(_.sumBy(this.model.po_detail, 'cost'), 4);
    }
	},
  created() {
    this.model = this.value
  },
  methods: {
    removeItem(index) {
      this.model.po_detail.splice(index, 1)
		},
		productChange(options, row){
			row.uom_id = options.data.props.uom_id
			row.uom_cat_id = options.data.props.uom_cat_id
		},
    onUomChange(row) {
      row.cost = this.getCostPrice({
        product_id: row.product_id,
        uom_id: row.uom_id,
      })
      this.calculate(row)
    },
    onCostThb(row){
      row.cost = row.cost_in_bath / this.model.fx_rate_thb
      this.calculate(row)
    },
    onCostUsd(row){
      row.cost_in_bath = row.cost * this.model.fx_rate_thb
      this.calculate(row)
    },
    calculate(row){
      if(row.discount_type == '%'){
        let discount = (row.cost * row.qty) * (row.discount_rate / 100)
        row.total_after_discount = (row.cost * row.qty) - discount
        row.total_after_discount_in_bath =  row.total_after_discount * this.model.fx_rate_thb
      }else {
        row.total_after_discount = (row.cost * row.qty) - row.discount_rate
        row.total_after_discount_in_bath = row.total_after_discount * this.model.fx_rate_thb
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.py {
  padding: 0.45rem 5px;
}
.max-h {
	min-height: 30vh;
  max-height: 50vh;
}
table {
  position: relative;
  border-collapse: collapse;
}
th {
	z-index: 3;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  background: rgb(242, 242, 242);
}
</style>